module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-12-fa9fa1d3b874fff6f6a0bd9e47b30fd7.svg";